import { StateParams } from '@uirouter/core';
import * as angular from 'angular';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { IRetailerRootScope } from '../../../core/models';
import { IShopperStaffDiscountTransaction } from '../../../model/IShopperStaffDiscountTransaction';
import { IShopperStaffDiscountTransactionIngredientItem, IShopperStaffDiscountTransactionItem } from '../../../model/IShopperStaffDiscountTransactionItem';
import { DiscountForStaffService } from './../../discount-for-staff.service';

class DiscountForStaffSingleTransaction {
    public static $inject = [
        '$stateParams',
        'notificationService',
        '$rootScope',
        'discountForStaffService'
    ];
    public model: IShopperStaffDiscountTransaction;
    public dataReady = false;
    public countryID: number;
    public IShopperStaffDiscountTransactionItem: IShopperStaffDiscountTransactionItem;

    constructor(
        private $stateParams: StateParams,
        private notificationService: NotificationService,
        public $rootScope: IRetailerRootScope,
        private discountForStaffService: DiscountForStaffService,
    ) {}

    public $onInit() {
        if (!this.$rootScope.userData) {
            return;
        }

        this.countryID = this.$rootScope.userData.countryID;
        const id = parseInt(this.$stateParams.id, 10);
        if (id) {
            this.getSingleTransaction(id);
        }
    }

    public getIngerdientQuantityDifference = (defaultQuantity: number, quantity: number ) => {
        return Math.abs(quantity - defaultQuantity);
    }

    public getDifferenceQuantity = (ingredient: IShopperStaffDiscountTransactionIngredientItem) => {
        return (ingredient.Quantity - ingredient.DefaultQuantity);
    }

    public getIngredientTotalPrice = (ingredient: IShopperStaffDiscountTransactionIngredientItem) => {
        return ingredient.Price * (ingredient.Quantity - ingredient.DefaultQuantity);
    }

    public isFreeIngredientPrice = (ingredient: IShopperStaffDiscountTransactionIngredientItem) => {
        return ingredient.Price === 0 || (ingredient.Quantity < ingredient.DefaultQuantity && ingredient.Quantity !== 0);
    }

    public async getSingleTransaction(transactionId: number) {
        try {
            this.model = await this.discountForStaffService.getTransaction(
                transactionId
            );
            this.dataReady = true;
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        } finally {
            this.notificationService.clearAll();
        }
    }
}

angular.module('naut').component('discountForStaffSingleTransaction', {
    template: require('./discount-for-staff-single-transaction.component.html'),
    controller: DiscountForStaffSingleTransaction,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/discountForStaff/transaction-tab/single-transaction/discount-for-staff-single-transaction.component.ts